import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
import {Grid, Typography} from '@mui/material';
import {useFormContext} from 'react-hook-form';
import {SecurityItemsList} from './SecurityItemsList';

export const Security = () => {
  const {
    watch,
    formState: {errors},
  } = useFormContext();

  const values = watch('menus.navigations.security') || {};
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Label
        </Typography>
        <RHFMultilingualField name={'menus.navigations.security.label'} />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Includings Title
        </Typography>

        <RHFMultilingualField
          name={'menus.navigations.security.includings.title'}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Includings Description
        </Typography>
        <RHFMultilingualField
          name={'menus.navigations.security.includings.description'}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Included Items
        </Typography>
        <SecurityItemsList
          listType={'Includings'}
          name='menus.navigations.security.includings.items'
          values={values?.includings?.items}
          errors={errors?.menus?.security?.includings?.items}
        />
      </Grid>

      <Grid item xs={12} mt={2}>
        <Typography variant='h6' mb={2}>
          Extras Title
        </Typography>
        <RHFMultilingualField
          name={'menus.navigations.security.extras.title'}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Extras Description
        </Typography>
        <RHFMultilingualField
          name={'menus.navigations.security.extras.description'}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Extra Items
        </Typography>
        <SecurityItemsList
          listType={'Extras'}
          name='menus.navigations.security.extras.items'
          values={values?.extras?.items}
          errors={errors?.menus?.security?.extras?.items}
        />
      </Grid>
    </Grid>
  );
};
